import { Block } from 'baseui/block';
import { ValueDisplay } from '../../components/ValueDisplay'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'

import { IFG_SAUTER_HeatingSetpoint } from './types'
import { SlGraph } from 'react-icons/sl';
import { useStyletron } from 'baseui';

export function OverviewPanel(props: IFG_SAUTER_HeatingSetpoint) {
    const [, theme] = useStyletron();
    
    return (
        <OverviewPanelWrapper icon={<SlGraph size={'100%'}  color={theme.colors.backgroundPrimary}></SlGraph>} {...props}>
            <Block display='flex' flexDirection='row' alignItems='baseline' justifyContent='center' gridGap='5px'>
                <ValueDisplay value={props.actSetpoint} dimension={'°C'}></ValueDisplay>
            </Block>
        </OverviewPanelWrapper>
    );
}